const __WEBPACK_NAMESPACE_OBJECT__ = require("@airtel-lego/sentry");